import { IconButton, InputAdornment } from "@mui/material";

import { TextField } from "@aclymatepackages/atoms";

import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NullableInput = ({ value = "", setValue, label }) => (
  <TextField
    label={label}
    InputProps={{
      endAdornment: !!value.length && (
        <InputAdornment position="end">
          <IconButton size="small" onClick={() => setValue("")}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </IconButton>
        </InputAdornment>
      ),
    }}
    value={value}
    setValue={setValue}
  />
);
export default NullableInput;
